<template>
    <div id="text_require" v-if="showtextEditor" @click.self="maskClickEvn">
        <div class="text_require">
            <div class="text_require1">
                <div>{{ titleText }}</div>
                <img @click="closePopup" class="cursor_1" src="../assets/image/icon_close.png" alt="">
            </div>
            <div class="text_require4">章节概述要求<span style="color: #ff8802;">(非必填)</span></div>
            <div class="text_require2">
                <el-input type="textarea" :maxlength="5000" show-word-limit :autosize="{ minRows: 8, maxRows: 8 }"
                    :placeholder="placeholder" v-model="requirement">
                </el-input>
            </div>

            <div class="text_require3">
                <div class="text_require3_1 cursor_1" @click="getRequire">立即生成</div>
            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
export default {
    props: {
        maskClick: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            placeholder: '请输入你的要求（无要求可直接点击立即生成）',
            requirement: '',
            showtextEditor: false,
            titleText: '换一换',
            type: '',//小说开头
            fx: ''//仿写内容
        }
    },
    methods: {
        open() {
            this.requirement = ''
            this.showtextEditor = true
        },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        closePopup() {
            this.showtextEditor = false
        },
        getRequire() {
            //当开启仿写状态的时候才会保存仿写内容
            EventBus.$emit('editor_chapter_hyh', this.requirement)
            this.closePopup()
        }
    }
}
</script>

<style lang="scss" scoped>
#text_require {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.text_require {
    background-color: #FFFFFF;
    border-radius: 5px;
}

.text_require1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 40px;
    width: 600px;
    font-weight: bold;
    font-size: 19px;
    color: #111111;
}

.text_require img {
    width: 21px;
    height: 21px;
}

.text_require2 {
    padding: 25px 40px;
}

.text_require3 {
    display: flex;
    justify-content: end;
    padding: 10px 40px;
}

.text_require3_1 {
    font-size: 17px;
    color: #FFFFFF;
    width: 125px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background: var(--tech-primary);
    border-radius: 8px;
}

.text_require4 {
    padding: 0 40px;
}
</style>